import React from 'react';

const WhoShouldAttend = () => {
  const audienceItems = [
    {
      icon: "fa-solid fa-briefcase",
      text: "HR Heads & HRBPs"
    },
    {
      icon: "fa-solid fa-bullseye",
      text: "Talent Acquisition & L&D Leaders"
    },
    {
      icon: "fa-solid fa-gear",
      text: "HR Managers driving transformation initiatives"
    }
  ];

  return (
    <section className="who-should-attend">
      <div className="container">
        <h2 className="section-title">Who Should Attend</h2>
        <p className="section-subtitle">This Build Lab is for mid-to-senior HR professionals who want to move beyond curiosity to application:</p>
        <div className="audience-list">
          {audienceItems.map((item, index) => (
            <div key={index} className="audience-item">
              <div className="icon-wrap">
                <i className={item.icon}></i>
              </div>
              <span>{item.text}</span>
            </div>
          ))}
        </div>
        <p className="audience-note">You don't need to be technical, just curious, forward-thinking, and ready to experiment.</p>
      </div>
    </section>
  );
};

export default WhoShouldAttend;
